import { Reveal } from "./Reveal";

const CHAPTERS = [
    {
        n: "01",
        h: "Le Drame du Télétravail",
        t: "Plus de 7 heures par jour comprimé sur des chaises inadaptées. Votre coccyx subit une charge continue équivalente à 3 fois votre poids corporel.",
    },
    {
        n: "02",
        h: "La Pression Anatomique",
        t: "Sans découpe ergonomique, les vertèbres sacrées sont écrasées. Cela provoque des douleurs sciatiques, des tensions lombaires et une fatigue chronique.",
    },
    {
        n: "03",
        h: "La Réhabilitation Ergonomique",
        t: "Ergocox™ redistribue scientifiquement le poids vers les ischions, libérant instantanément la zone coccygienne pour un alignement vertébral naturel.",
    },
];

export default function Manifesto() {
    return (
        <section id="manifeste" className="relative bg-sage-hover text-cream py-20 lg:py-32 overflow-hidden">
            <div className="absolute -top-24 right-0 w-[500px] h-[500px] rounded-full bg-sage/40 blur-3xl pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <p className="text-xs uppercase font-mono tracking-[0.25em] text-cream/50">
                        Le Manifeste de la Station Assise
                    </p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl leading-[1.1]">
                        Votre douleur n’est pas une fatalité.
                        <span className="italic text-terra"> Elle est une mauvaise conception.</span>
                    </h2>
                </Reveal>
                <div className="mt-14 lg:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
                    {CHAPTERS.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.12} className="h-full">
                            <div
                                data-testid={`manifesto-chapter-${i + 1}`}
                                className="h-full border-t border-cream/20 pt-8 group hover:border-terra/60 transition-colors duration-500"
                            >
                                <span className="font-serif italic text-6xl lg:text-7xl text-cream/15 group-hover:text-terra/40 transition-colors duration-500">
                                    {c.n}
                                </span>
                                <h3 className="mt-6 font-serif text-2xl lg:text-3xl text-cream">{c.h}</h3>
                                <p className="mt-4 text-sm lg:text-base text-cream/70 leading-relaxed">{c.t}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
